"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
// A caret SVG for which we can specify a color. The upsideDown param is for inverting the caret.
const IconDownCaret = _ref => {
  let {
    alt,
    color,
    direction,
    style,
    upsideDown
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", {
    // @ts-ignore
    alt: alt,
    fill: "none",
    height: 14,
    style: {
      [direction === 'ltr' ? 'left' : 'right']: '5px',
      position: 'relative',
      transform: upsideDown ? 'rotate(-180deg)' : '',
      transition: 'transform .1s linear',
      ...style
    },
    viewBox: "0 0 14 14",
    width: 18,
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    clipRule: "evenodd",
    d: "M11.5816 4.75144C11.6955 4.86535 11.6955 5.05002 11.5816 5.16392L7.12114 9.62435C6.89333 9.85215 6.52399 9.85215 6.29618 9.62435L1.83575 5.16392C1.72185 5.05002 1.72185 4.86535 1.83575 4.75144C1.94966 4.63754 2.13433 4.63754 2.24823 4.75144L6.70866 9.21187L11.1691 4.75144C11.283 4.63754 11.4677 4.63754 11.5816 4.75144Z",
    fillRule: "evenodd",
    style: {
      fill: color,
      stroke: color,
      strokeWidth: 1
    }
  }));
};
var _default = exports.default = IconDownCaret;